import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type {
	BackendSessionResponse,
	BaseItemSchema,
} from "@memorang/types/src/session/new-session";
import type {
	CreateSessionRequest,
	EndSessionRequest,
	EndSessionResponse,
	TrackAnswerEventRequest,
	TrackAnswerEventResponse,
} from "./types";

type UpdateSessionBreakRequest = {
	sessionId: number;
	config: {
		allotedTime: number;
		section: string;
		startTime: string;
		status: string;
		totalBreakTimeTakenInSeconds: number;
	}[];
};

export const updateSessionBreak = async (
	payload: UpdateSessionBreakRequest,
): Promise<void> => {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/assessments/v1/responses/break-events`,
		payload,
	);

	return data.data;
};

export const getItemDetails = async (payload: {
	itemId: number;
	userId: number;
}): Promise<{
	data: {
		items: BaseItemSchema[];
	};
}> => {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/assessments/v1/users/get-item-details`,
		payload,
	);

	return data;
};

export async function createSession(
	request: CreateSessionRequest,
): Promise<BackendSessionResponse> {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/assessments/v1/sessions`,
		request,
		{
			headers: {
				"Content-Type": "application/json",
			},
		},
	);

	return data.data;
}

export async function endSession(
	request: EndSessionRequest,
): Promise<EndSessionResponse> {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/assessments/v1/sessions/${request.sessionId}/end`,
	);
	return data.data;
}

export async function trackAnswerEvent(
	request: TrackAnswerEventRequest,
): Promise<TrackAnswerEventResponse> {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/assessments/v1/responses/answer-events`,
		request,
		{
			headers: {
				"Content-Type": "application/json",
				// Add any necessary authentication headers here
			},
		},
	);

	return data.data;
}
export const fetchSessionItems = async ({
	sessionId,
}: {
	sessionId: number;
}): Promise<BackendSessionResponse> => {
	const { data } = await authAxios.get(
		`${API_BASE_URL}/assessments/v1/sessions/${sessionId}/items`,
	);
	return data.data;
};
